angular.module('app').factory('SettlementFilesService', function () {
    const fac = {
        filterForTester: filterForTester
    };
    return fac;
    function filterForTester(testerId, files) {
        return _.filter(files, { UserId: testerId });
    }
});
